import dataManipulation from '~/helpers/dataManipulation';
import { useI18n } from '~/helpers/hooks/usei18n';
import { useContext } from '@nuxtjs/composition-api';
import cookieNames from '~/enums/cookieNameEnum';

const getEstimatedDelivery = () => {
  const { daysFromNowTo } = dataManipulation();
  const trans = useI18n();
  const { app } = useContext();

  const getShipDays = (product, market, channel) => {
    let shipFromDays = null;
    let shipToDays = null;
    let shipFromAttribute = product?.sdc_ship_date_1 || '';
    let shipToAttribute = product?.sdc_ship_date_2 || '';
    if (shipFromAttribute && shipToAttribute) {
      shipFromAttribute = JSON.parse(shipFromAttribute);
      shipToAttribute = JSON.parse(shipToAttribute);
      shipFromDays = shipFromAttribute.find((e) => e && e.market === market && e.channel === channel && e.value);
      shipToDays = shipToAttribute.find((e) => e && e.market === market && e.channel === channel && e.value);
    }
    return shipFromDays && shipToDays ? [shipFromDays, shipToDays] : null;
  };

  const getEstimatedDeliveryDates = (product) => {
    let dates = null;
    const market = app.$cookies.get(cookieNames.marketCookieName) || '';
    const channel = 'grn:channelmanager:channel::642acc84f924ae3c5c3dd5a3';
    if (market && channel) {
      let shipDays = null;
      if (product?.configurable_product_options_selection?.variant) {
        shipDays = getShipDays(product.configurable_product_options_selection.variant, market, channel);
      }
      if (!shipDays && product) {
        shipDays = getShipDays(product, market, channel);
      }
      if (shipDays) {
        dates = [daysFromNowTo(shipDays[0].value), daysFromNowTo(shipDays[1].value)];
      }
    }
    return dates;
  };

  const getEstimatedDeliveryLabelFromDates = (dates) => {
    if (!dates || !dates[0] || !dates[1]) return '';
    const yearIsDifferent = dates[0].year !== dates[1].year;
    const startDate = `${dates[0].day} ${trans.t(dates[0].month)} ${yearIsDifferent ? dates[0].year : ''}`;
    const endDate = `${dates[1].day} ${trans.t(dates[1].month)} ${yearIsDifferent ? dates[1].year : ''}`;
    return trans.t('estimatedDelivery', [startDate, endDate]);
  };

  const getEstimatedDeliveryLabel = (product) => {
    const dates = getEstimatedDeliveryDates(product);
    return getEstimatedDeliveryLabelFromDates(dates);
  };

  const isPreviousDate = (firstDate, secondDate) => {
    return (
      firstDate.year < secondDate.year ||
      (firstDate.year === secondDate.year &&
        (firstDate.month < secondDate.month || (firstDate.month === secondDate.month && firstDate.day < secondDate.day)))
    );
  };

  const getEstimatedDeliveryLabelTotal = (products) => {
    let startDate = null;
    let endDate = null;
    products.forEach((product) => {
      const dates = getEstimatedDeliveryDates(product);
      if (dates) {
        if (!startDate || isPreviousDate(dates[0], startDate)) {
          startDate = dates[0];
        }
        if (!endDate || isPreviousDate(endDate, dates[1])) {
          endDate = dates[1];
        }
      }
    });
    return getEstimatedDeliveryLabelFromDates([startDate, endDate]);
  };

  return {
    getEstimatedDeliveryLabel,
    getEstimatedDeliveryLabelTotal,
  };
};

export default getEstimatedDelivery;
